const routes = [
  {
    path: "/manutencao-vinculo-contrato",
    name: "manutencao-vinculo-contrato",
    meta: {
      allowedPermissions: ["vinculo_contrato_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoVinculoContrato/ManutencaoVinculoContratoHome.vue"
      ),
  },

  {
    path: "/manutencao-vinculo-contrato/novo",
    name: "manutencao-vinculo-contrato-novo",
    meta: {
      allowedPermissions: ["vinculo_contrato_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoVinculoContrato/ManutencaoVinculoContratoCad.vue"
      ),
  },

  {
    path: "/manutencao-vinculo-contrato/editar/:id",
    name: "manutencao-vinculo-contrato-editar",
    meta: {
      allowedPermissions: ["vinculo_contrato_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoVinculoContrato/ManutencaoVinculoContratoEdit.vue"
      ),
  },
];

export default routes;
